import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from '../../../services/session'
import CONFIG_COMPANY from "../../../services/myConfig";

const AdminApiService = new AdminApi()


export default {
    data() {
        return {
            id: 0,
            model: {},
            androidVersion: 0,
            huaweiVersion: 0,
            iosVersion: 0,
            selectedImage: null,
            selectedImagePreview: null,
            imageUrl: null,
            versionInReviewAndroid: 0,
            versionInReviewHuawei: 0,
            versionInReviewIOS: 0,
        }

    },
    methods: {
        update: update,
        getCompany: getCompany,
        getCurrentVersion: getCurrentVersion,
        onUpdateVersionClicked: onUpdateVersionClicked,
        loadTextFromFile: loadTextFromFile,
        uploadPhoto: uploadPhoto,
        deleteImage: deleteImage,
        updateVersion: updateVersion,
        getCompanyConfiguration: getCompanyConfiguration,
        updateReviewVersion: updateReviewVersion,
        isNull: isNull,
    },
    beforeMount() {
        if(session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }

        this.id = this.$route.query.id;
        this.getCompany()
    }
}

function deleteImage(){
    this.selectedImage = null;
    this.selectedImagePreview = null;
    this.imageUrl = null;
    this.model.logoUrl = null;
}

function loadTextFromFile(ev) {
    var i = 0;
    for (i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        if (file.size > 5000000) {
            alert(this.locale.t('label_max_size_picture'))
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }

}

function getCompany(){
    let _self = this;
    AdminApiService.getCompany(this.$route.query.id)
        .then((response) => {
            _self.model.maxHourToVisibleSlot = null;
            _self.model.maxDiffToVisibleSlot = null;
            _self.model.maxReserveTrainingAsDebtor = null;
            _self.imageUrl = response.data.logoUrl;
            _self.model = response.data;
            _self.getCurrentVersion()
            _self.getCompanyConfiguration(_self.model.name)
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function getCurrentVersion(){
    let _self = this;
    AdminApiService.getCurrentVersion(_self.model.name)
        .then((response) => {
           response.data.forEach(e => {
               if(e.device === "ANDROID"){
                   _self.androidVersion = e.versionCode;
               }
               if(e.device === "HUAWEI"){
                   _self.huaweiVersion = e.versionCode;
               }
               if(e.device === "IOS"){
                   _self.iosVersion = e.versionCode;
               }
           })
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function onUpdateVersionClicked(){
    let modelAndroid = {
        applicationType: "ANDROID",
        versionCode: parseInt(this.androidVersion),
        company: this.model.name
    }
    this.updateVersion(modelAndroid)

    let modelHuawei = {
        applicationType: "HUAWEI",
        versionCode: parseInt(this.huaweiVersion),
        company: this.model.name
    }
    this.updateVersion(modelHuawei)

    let modelIos = {
        applicationType: "IOS",
        versionCode:  parseInt(this.iosVersion),
        company: this.model.name
    }
    this.updateVersion(modelIos)
}

function updateVersion(model){
    let _self = this;
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});
    AdminApiService.updateVersion(model)
        .then((response) => {
            swal('Success', 'Verzije azurirane', 'success')
            _self.getCompany();
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}

function uploadPhoto() {
    if(this.selectedImage == null){
        this.update(this.model.logoUrl)
        return
    }
    let _self = this;
    AdminApiService.uploadCompanyLogoImage(this.model.name, this.selectedImage)
        .then((response) => {
            _self.update(response.data.url)
        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function update(url) {
    let id = this.id;
    let model = {
        userCount: this.model.userCount,
        trainingTypes: this.model.trainingTypes,
        userVisibleDays: this.model.userVisibleDays,
        adminVisibleDays: this.model.adminVisibleDays,
        minutesToCancelTraining: this.model.minutesToCancelTraining,
        companyMail: this.model.companyMail,
        displayName: this.model.displayName,
        fromMail: this.model.fromMail,
        limits: this.model.limits,
        maxHourToVisibleSlot: this.model.maxHourToVisibleSlot,
        maxDiffToVisibleSlot: this.model.maxDiffToVisibleSlot,
        maxReserveTrainingAsDebtor: this.model.maxReserveTrainingAsDebtor,
        sendMailKey: this.model.sendMailKey,
        hasTerms: this.model.hasTerms,
        usernameForAppStore: this.model.usernameForAppStore,
        usernameForShop: this.model.usernameForShop,
        logoUrl: url
    }
    AdminApiService.updateCompany(model, id)
        .then((response) => {
            swal('Success', 'Kompanija ažurirana', 'success')
            this.$router.push('/companies')
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function getCompanyConfiguration(name){
    let _self = this;
    AdminApiService.getCompanyConfiguration(name)
        .then((response) => {
            _self.versionInReviewIOS = _self.isNull(response.data.versionInReviewIOS, 0);
            _self.versionInReviewAndroid = _self.isNull(response.data.versionInReviewAndroid, 0);
            _self.versionInReviewHuawei = _self.isNull(response.data.versionInReviewHuawei, 0);
        })
        .catch(error => {
            console.log(error)
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function isNull(value, def){
    if(value == null) return def
    return value
}

function updateReviewVersion(){
    let _self = this;
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});
    let model = {
        company: _self.model.name,
        versionInReviewAndroid: _self.versionInReviewAndroid,
        versionInReviewHuawei: _self.versionInReviewHuawei,
        versionInReviewIOS: _self.versionInReviewIOS,
    }
    AdminApiService.updateReviewVersion(model)
        .then((response) => {
            swal('Success', 'Verzije review azurirane', 'success')
            _self.getCompany();
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Company/Edit/EditCompany.js